export default __webpack_public_path__ + "static/media/003-avocado.ec42428a.svg";